export default "<app-baner-fichas></app-baner-fichas>\n\n";